import React, { Component, Fragment } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';
import EmployeeForm from './EmployeeForm';
import './App.css';
import centroLogo from "./img/centro.png";
import pqLogo from "./img/pq_logo.png";
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';

export default class App extends Component {

  constructor(props){
    super(props);
    this.pickMulti = React.createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.changePass = this.changePass.bind(this);
    this.urlParams = new URLSearchParams(window.location.search);
    this.incrementMinMonthList = [5832, 5846];
    this.monthPickerLimitMin = {year: parseInt(moment().format('YYYY')), month: parseInt(moment().format('M'))};
    this.monthPickerLimitMax = {year: parseInt(moment().add(11, 'months').format('YYYY')), month: parseInt(moment().add(11, 'months').format('M'))};
    let validity = this.monthPickerLimitMin;
    this.env = process.env.REACT_APP_ENVIRONMENT ? process.env.REACT_APP_ENVIRONMENT.toLowerCase() : '';
    this.baseUrl = process.env.REACT_APP_API_URL;
    this.stripeKey = process.env.REACT_APP_STRIPE_KEY;
    this.activateSuiteForLot = [5741, 5751]; 
    this.isVIP = this.props.vip;
    this.isVendor = this.props.vendor;
    this.isFiu = this.props.fiu;
    this.isResident1 = this.props.resident1;
    this.state = {
      subscriptionType: 'individual',
      passesScreenActive: true,
      fields: {
        areaCode: 1,
        areaCode2: 1,
        email: ''
      },
      userEmail: [{email: ''}],
      vehicleDetail: [{vehicle_no: '', vehicle_type: '', vehicle_make: '', vehicle_model: '' }],
      errors: {},
      arenaId: this.urlParams.get('id'),
      setOpen: false,
      validity,
      no_of_spots: 1,
      no_of_vehicles: 1,
      visible: this.urlParams.get('visible')
    };
  }

  componentDidMount(){
    this.getArena();
    window.addEventListener('click', (e) => {  
      this.handleOutsideClick(e);
    });
  }

  onOpenModal(){
    this.setState({
      setOpen: true
    })
  } 
  onCloseModal(){
    this.setState({
      setOpen: false
    })
  }

  initStripe(){
    this.stripe = window.Stripe(this.stripeKey);
    console.log("===this.stripe===", this.stripe);
    var elements = this.stripe.elements();

      var style = {
        base: {
          iconColor: '#666EE8',
          color: '#000',
          lineHeight: '40px',
          fontSize: '16px',
      
          '::placeholder': {
            color: '#000',
            fontWeight: 300,
            fontSize: '13px'
          },
        },
      };

      this.card = elements.create('card', {style: style, hidePostalCode: false});

      this.card.mount('#card-element');

      this.card.addEventListener('change', function(event) {
        var displayError = document.getElementById('card-errors');
        if (event.error) {
          displayError.textContent = event.error.message;
        } else {
          displayError.textContent = '';
        }
      });
  }

  handleOutsideClick(e){
    let mql = window.matchMedia('(min-width: 1200px)');
    if (!mql.matches && e.target.className != 'mp-btn' && !e.target.classList.contains('rmp-btn') && e.target.className != 'add-delete-icon' && document.querySelector('.monthly-consumer') && !document.querySelector('.monthly-consumer').contains(e.target)){
      this.setState({
        passesScreenActive: true,
        selectedPass: ''
      })
    }
  }

  refreshAfterSleep(){
		var SAMPLE_RATE = 5000; 
		var lastSample = Date.now();
	  
		function refresh() {
		  if (Date.now() - lastSample >= SAMPLE_RATE * 2) {
			window.location.reload();
		  }
		  lastSample = Date.now();
		  setTimeout(refresh, SAMPLE_RATE);
		}
		refresh();
  }

  manageBodyBackground(isShow){
    if(isShow){
      document.querySelector('#root').classList.add('dark');
    }else{
      document.querySelector('#root').classList.remove('dark');
    }
  }

  handleFocus(name){
    document.querySelector(`input[name="${name}"]`).focus();
    return false;
  }

  getArena(){
    const urlParams = new URLSearchParams(window.location.search);
    fetch(`${this.baseUrl}/parking/arena/details?arena_hash=${urlParams.get('id')}`)
        .then(response => response.json())
        .then(resp => {
          if(resp.data && resp.status === "SUCCESS"){
            const is45SECase = resp.data.id === 5832;
            const showTemplate = urlParams.get('pricing_type');
            this.setState({
              parkingId: resp.data.id,
              is45SECase,
              showTemplate,
              name: resp.data.name,
              isShowSuite: this.activateSuiteForLot.includes(resp.data.id),
              validity: this.state.validity
              // validity: this.incrementMinMonthList.includes(resp.data.id) ? {year: parseInt(moment().format('YYYY')), month: 6}  : this.state.validity
            }, () => {
              if(this.isResident1) this.getUnitDetails(resp.data.id);
            })
          }else{
            let errMsg = resp.error && resp.error.reason ? resp.error.reason : 'Something went wrong'; 
            toast.error(errMsg);
          }
        })
        .catch((error) => {
            toast.error('Something went wrong');
        });
  }

  getUnitDetails(parkingId){
    fetch(`${this.baseUrl}/parking/unit/list?parking_id=${parkingId}`)
      .then(response => response.json())
      .then(resp => {
        if(resp.data && resp.status === "SUCCESS"){
          this.setState({ unitList: resp.data });
        }else{
          let errMsg = resp.error && resp.error.reason ? resp.error.reason : 'Something went wrong';
          toast.error(errMsg);
        }
      })
      .catch(() => {
        toast.error('Something went wrong');
      });
  }
  

  handleSubmit(e, id, card, request){
    const submitBtn = document.getElementById("pay-submit");
    submitBtn.disabled = true;
    this.setState({loading : true});   
    let istypeAccount = request.type === 'account';
    fetch(`${this.baseUrl}/special/parking/add/data/list`, {
      method: 'post',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify(request)
     })
      .then(response => response.json())
      .then(resp => {
        if(resp.status === "SUCCESS" && resp.data){
          window.scrollTo(0,0);
          this.setState({booked: true, loading: false});
        }else{
          let errMsg = resp.error && resp.error.reason ? resp.error.reason : 'Something went wrong'; 
          this.manageBodyBackground(false);
          this.setState({loading : false});
          toast.error(errMsg, { autoClose: errMsg.length > 20 ? 10000 : 2000 });
          submitBtn.disabled = false;
        }
      })
      .catch((error) => {
        this.manageBodyBackground(false);
        this.setState({loading : false});
        toast.error('Something went wrong');
        submitBtn.disabled = false;
      });  
  }

  handleSubscriptionType(type){
    this.setState({
      subscriptionType: type
    })
  }

  handlePassSelection(item){
    this.setState({
      passesScreenActive: false,
      selectedPass: item
    }, () => this.calculateAccountPrice())
  }

  changePass(){
    this.setState({
      passesScreenActive: true,
      selectedPass: ''
    })
  }

  render() {
    return (
      <div style={{position: 'relative'}}>
        {this.state.isVehicleOnboarded === false &&  <div style={{position: 'absolute', width: '100%', height: '100%', zIndex: 10, backgroundColor: 'rgba(255, 255, 255, 0.90)'}}></div>}
        {this.state.loading &&  <div style={{position: 'absolute', width: '100%', height: '100%', zIndex: 10}}></div>}
        {this.state.loading && <div className="loader">Loading...</div>}
        
        <div style={{display: this.state.booked ? 'block' : 'none'}} className="success-message">
          {/* <span onClick={this.handleClose.bind(this)} id="sm-close">&times;</span> */}
          <svg viewBox="0 0 76 76" className="success-message__icon icon-checkmark">
            <circle cx="38" cy="38" r="36"></circle>
            <path fill="none" stroke="#FFFFFF" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M17.7,40.9l10.9,10.9l28.7-28.7" style={{strokeDashoffset: 0, strokeDasharray: 56.0029}}></path>
          </svg>
          <h3 className="success-message__title">Sent Successfully</h3>
          <p style={{position: 'relative', top: '28px', fontSize: '12px', color: '#888'}}>(You can close this tab)</p>
          {/* <div className="success-message__content">
              <p>Booking Id: {this.state.bookingID}</p>
          </div> */}
        </div>
        <div>
          {this.state.parkingId == 5741 ? <div style={{ paddingTop: 10, paddingBottom: 20, margin: '0 -10px'}}>
            <img style={{height: 45, float: 'left'}} src={pqLogo} />
            <img style={{height: 21, marginTop: 12, float: 'right'}} src={centroLogo} />
            <div style={{clear: 'both'}}></div>
          </div> :
          <div style={{textAlign: 'center', paddingBottom: '20px'}}>
            <img style={{height: 85}} src="https://portal.parkquility.com/public/pq_logo.png" />
          </div>}
          {this.state.passesScreenActive && <div>
            <p style={{textAlign: 'center', color: '#666565'}}>{this.state.name}</p>
          </div>}
        </div>
        
          {!this.state.booked && <EmployeeForm 
            toast={toast}
            onOpenModal={this.onOpenModal.bind(this)}
            onCloseModal={this.onCloseModal.bind(this)}
            handleSubmit={this.handleSubmit.bind(this)}
            selectedPass={this.state.selectedPass}
            subscriptionType={this.state.subscriptionType}
            parkingId={this.state.parkingId}
            isPayment={this.state.isPayment}
            changePass={this.changePass.bind(this)}
            isVIP={this.isVIP}
            isVendor={this.isVendor}
            isFiu={this.isFiu}
            isResident1={this.isResident1}
            unitList={this.state.unitList}
          />}
        <ToastContainer autoClose={2000} closeButton={true} style={{fontSize: 14}}/>
      </div>    
    )
  }
}
